module.exports = __webpack_public_path__ + "static/media/Caixa4.3b9de7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa4.png
// module id = 2033
// module chunks = 0